
<script>
	import { crate } from "../../../wasm.js";
	const { Color, PieceKind } = crate;

	export let piece;
    export let dim;


	$: data = (() => {
		const colorName = (() => {
			switch (piece.color) {
				case Color.White:
					return "white";
				case Color.Black:
					return "black";
				default:
					return "unknown";
			}
		})();

		const pieceName = (() => {
			switch (piece.kind) {
				case PieceKind.Pawn:
					return "pawn";
				case PieceKind.Knight:
					return "knight";
				case PieceKind.Bishop:
					return "bishop";
				case PieceKind.Rook:
					return "rook";
				case PieceKind.Queen:
					return "queen";
				case PieceKind.King:
					return "king";
				default:
					return "unknown";
			}
		})();

		return {
            src: `/assets/images/${colorName}-${pieceName}.png`,
            alt: `${colorName} ${pieceName}`,
        };
	})();
</script>

<div class="root centered" class:dim>
    <img src={data.src} alt={data.alt} />
</div>

<style>
	.root {
        width: 100%;
        height: 100%;
    }

    .root img {
        width: 100%;
        height: 100%;
        pointer-events: none;
    }

    .dim {
        opacity: 0;
    }
</style>
